import { AfterViewInit, Component } from '@angular/core';
import { OrganizationService } from './core/auth/services/organization.service';
import { AuthService } from './core/auth/services/auth.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements AfterViewInit {

  constructor(private organizationService: OrganizationService, private auth: AuthService) { }

  ngAfterViewInit(): void {
    this.setDarkModeByDefault();
    this.getOrganization();
  }

  setDarkModeByDefault() {
    document.body.classList.toggle('dark', true);
  }

  getOrganization() {
    const organization = this.auth.getActiveOrganization();
    if(organization) {
      this.organizationService.setSelectedOrganization(organization);
    }

  }
}


